module.exports = __webpack_public_path__ + "img/Bitmap@22x.29e2d716.png";